import { Fragment } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import type {
  FieldGroupDescription,
  NamedField,
} from "@/v2-backoffice-client/tenant/privacy/tenant.privacy.utils"

export type TenantPrivacyHistoryFieldNamesProps = {
  description: FieldGroupDescription
}

// A comma list of field names. A field the person procedures never disclose
// is greyed, the way the editor greys its column: it was written, but it
// changes nothing a user sees.
function FieldList(props: { fields: NamedField[]; conjunction: string }) {
  const { fields, conjunction } = props

  return fields.map((field, index) => (
    <Fragment key={field.columnName}>
      {index > 0 && (index === fields.length - 1 ? conjunction : ", ")}
      <span className={cn(!field.isEnforced && "text-muted-foreground")}>
        {field.label}
      </span>
    </Fragment>
  ))
}

// Which fields a transition covers, said the short way: "Every field",
// "Every field except Name", or the names themselves.
function TenantPrivacyHistoryFieldNames(
  props: TenantPrivacyHistoryFieldNamesProps,
) {
  const { description } = props

  if (description.kind === "every") return "Every field"

  if (description.kind === "except") {
    return (
      <>
        Every field except{" "}
        <FieldList fields={description.fields} conjunction=" and " />
      </>
    )
  }

  return <FieldList fields={description.fields} conjunction=", " />
}

export default TenantPrivacyHistoryFieldNames
